import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Deactivation-Popup.scss';
import { Button } from '@material-ui/core';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    height: 200,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(5, 4, 3),
  },
}));

const DeactivationPopupModel = (props) => {
  const { deactivationPopUp, onDeactivation, onDeactivationCancel } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    onDeactivationCancel();
  };

  const onDeleteClick = (e) => {
    onDeactivation(e);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='deactivation-popup'>
        <div className='deactivation-popup-title'>
          {deactivationPopUp.title}
          <div>{deactivationPopUp.name}?</div>
        </div>
        <div className='col-md-10 offset-1 d-flex justify-content-around mt-4'>
          <Button
            variant='outlined'
            size='large'
            color='secondary'
            className='deactivation-popup-button-size'
            onClick={(e) => handleClose()}
          >
            No
          </Button>
          <Button
            variant='contained'
            size='large'
            color='primary'
            className='deactivation-popup-button-size'
            onClick={(e) => onDeleteClick(e)}
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={deactivationPopUp.isActive} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default DeactivationPopupModel;
